import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { FiEye, FiMessageSquare, FiUsers, FiTrendingUp, FiEdit3, FiBarChart2 } from 'react-icons/fi';

const AdminDashboard = () => {
  const [analytics, setAnalytics] = useState(null);
  const [contactStats, setContactStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [analyticsRes, contactRes] = await Promise.allSettled([
        api.get('/analytics/dashboard'),
        api.get('/contact/stats')
      ]);
      if (analyticsRes.status === 'fulfilled') setAnalytics(analyticsRes.value.data);
      if (contactRes.status === 'fulfilled') setContactStats(contactRes.value.data);
    } catch (err) {
      console.error('Dashboard error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="spinner"></div>;

  const overview = analytics?.overview || {};

  return (
    <div>
      <div className="admin-page-header">
        <h1>Dashboard</h1>
        <span style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
          Welcome back, Dr. Panchal
        </span>
      </div>

      {/* Stats Grid */}
      <div className="stats-grid">
        <div className="stat-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <FiEye size={18} color="var(--accent-primary)" />
            <span className="stat-label">Total Views</span>
          </div>
          <div className="stat-value">{overview.totalViews || 0}</div>
          <div className="stat-sub">Today: {overview.todayViews || 0}</div>
        </div>

        <div className="stat-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <FiUsers size={18} color="var(--accent-primary)" />
            <span className="stat-label">Unique Visitors</span>
          </div>
          <div className="stat-value">{overview.totalUnique || 0}</div>
          <div className="stat-sub">Today: {overview.todayUnique || 0}</div>
        </div>

        <div className="stat-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <FiMessageSquare size={18} color="var(--accent-primary)" />
            <span className="stat-label">Messages</span>
          </div>
          <div className="stat-value">{contactStats?.total || 0}</div>
          <div className="stat-sub">Unread: {contactStats?.unread || 0}</div>
        </div>

        <div className="stat-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <FiTrendingUp size={18} color="var(--accent-primary)" />
            <span className="stat-label">This Week</span>
          </div>
          <div className="stat-value">{overview.weekViews || 0}</div>
          <div className="stat-sub">Month: {overview.monthViews || 0}</div>
        </div>
      </div>

      {/* Quick Links */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '32px' }}>
        <Link to="/drnileshpanchal/messages" className="card" style={{ textDecoration: 'none', textAlign: 'center', padding: '24px' }}>
          <FiMessageSquare size={24} color="var(--accent-primary)" />
          <h3 style={{ fontSize: '1.1rem', marginTop: '12px', color: 'var(--text-primary)' }}>Messages</h3>
          <p style={{ fontSize: '0.88rem', color: 'var(--text-muted)', marginTop: '4px' }}>
            {contactStats?.unread || 0} unread
          </p>
        </Link>
        <Link to="/drnileshpanchal/content" className="card" style={{ textDecoration: 'none', textAlign: 'center', padding: '24px' }}>
          <FiEdit3 size={24} color="var(--accent-primary)" />
          <h3 style={{ fontSize: '1.1rem', marginTop: '12px', color: 'var(--text-primary)' }}>Edit Content</h3>
          <p style={{ fontSize: '0.88rem', color: 'var(--text-muted)', marginTop: '4px' }}>Manage sections</p>
        </Link>
        <Link to="/drnileshpanchal/analytics" className="card" style={{ textDecoration: 'none', textAlign: 'center', padding: '24px' }}>
          <FiBarChart2 size={24} color="var(--accent-primary)" />
          <h3 style={{ fontSize: '1.1rem', marginTop: '12px', color: 'var(--text-primary)' }}>Analytics</h3>
          <p style={{ fontSize: '0.88rem', color: 'var(--text-muted)', marginTop: '4px' }}>View detailed stats</p>
        </Link>
      </div>

      {/* Recent Visitors */}
      {analytics?.recentVisitors?.length > 0 && (
        <div>
          <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.2rem', marginBottom: '16px' }}>
            Recent Visitors
          </h3>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Time</th>
                <th>Page</th>
                <th>Browser</th>
                <th>OS</th>
                <th>Device</th>
              </tr>
            </thead>
            <tbody>
              {analytics.recentVisitors.slice(0, 10).map((v, i) => (
                <tr key={i}>
                  <td>{new Date(v.createdAt).toLocaleString()}</td>
                  <td>{v.page}</td>
                  <td>{v.browser}</td>
                  <td>{v.os}</td>
                  <td style={{ textTransform: 'capitalize' }}>{v.device || 'desktop'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
